import * as yup from "yup";

export const schema = yup.object().shape({
  access_profile_id: yup.number().notRequired().nullable(),
});
